import script from "./SidebarGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarGeneral.vue?vue&type=script&setup=true&lang=js"

import "./SidebarGeneral.vue?vue&type=style&index=0&id=1e1a563b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1a563b"]])

export default __exports__